import { render, staticRenderFns } from "./Pendingreport.vue?vue&type=template&id=0bd2b541&"
import script from "./Pendingreport.vue?vue&type=script&lang=js&"
export * from "./Pendingreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports